import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useEffect, useState } from 'react';
import * as stylex from '@stylexjs/stylex';
import DeviceAwareDiv400 from "nood-comp/src/comp/ui/containers/DeviceAwareDiv400";
import Spacer from "nood-comp/src/comp/ui/spacer/Spacer";
import Form from "nood-comp/src/comp/form/Form";
import AddOrEditButton from "nood-comp/src/comp/button/AddOrEditButton";
import { useURLParam } from "nood-comp/src/hooks/useURLParam";
import TextField from "nood-comp/src/comp/form/textfield/TextField";
import FlexVertical from "nood-comp/src/comp/ui/containers/flex-boxes/FlexVertical";
import { _post, _put, isHttpOK } from "nood-comp/src/net/xhr";
import { __feedback } from "src/app/msg";
import Textarea from "nood-comp/src/comp/form/textarea/Textarea";
import RichTextfield from "nood-comp/src/comp/text/rte/RichTextfield";
import OptionPicker from "nood-comp/src/comp/form/dropdown/OptionPicker";
import PickDate from "nood-comp/src/comp/date/picker/PickDate";
import PickTime from "nood-comp/src/comp/date/picker/PickTime";
import FlexHorizontal from "nood-comp/src/comp/ui/containers/flex-boxes/FlexHorizontal";
import { useHttpGetWithId } from "nood-comp/src/hooks/useHttpGetWithId";
export default function VoucherCampaignEditor(props) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    campaignObject = _useState2[0],
    setCampaignObject = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    isValid = _useState4[0],
    setIsValid = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    isProcessing = _useState6[0],
    setIsProcessing = _useState6[1];
  var id = useURLParam("id");
  var isEdit = id !== void 0 && id !== null;
  var __saveOrUpdate = function __saveOrUpdate(obj) {
    if (isValid && !isProcessing) {
      setIsProcessing(true);
      if (isEdit && id) {
        _put("/voucher-campaign/".concat(id), campaignObject, function (res) {
          __feedback(res);
          setIsProcessing(false);
        });
      } else {
        _post("/voucher-campaign", campaignObject, function (res) {
          __feedback(res);
          setIsProcessing(false);
          if (isHttpOK(res)) {
            setCampaignObject({});
          }
        });
      }
    }
  };
  useHttpGetWithId({
    path: "/voucher-campaign",
    id: id,
    setter: setCampaignObject
  });
  useEffect(function () {
    if (campaignObject !== null && campaignObject !== void 0 && campaignObject.code_type) {
      if (campaignObject.code_type === 'UNIQUE') {
        setCampaignObject(_objectSpread(_objectSpread({}, campaignObject), {}, {
          max_redemptions_per_user: 1
        }));
      } else if (campaignObject.code_type === 'SHARED') {
        setCampaignObject(_objectSpread(_objectSpread({}, campaignObject), {}, {
          max_redemptions: undefined,
          max_redemptions_per_user: undefined
        }));
      }
    }
  }, [campaignObject === null || campaignObject === void 0 ? void 0 : campaignObject.code_type]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    mtop: 30
  }), /*#__PURE__*/React.createElement(DeviceAwareDiv400, {
    pad: 30
  }, /*#__PURE__*/React.createElement(Form, {
    obj: campaignObject,
    __setter: setCampaignObject,
    __validSetter: setIsValid,
    __submit: function __submit(obj, errors, submitCallback) {
      __saveOrUpdate(obj);
    }
  }, /*#__PURE__*/React.createElement(FlexVertical, {
    gap: 10
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Code",
    icon: "tag",
    name: "code",
    validations: ['required']
  }), /*#__PURE__*/React.createElement(TextField, {
    label: "Name",
    icon: "menu",
    name: "name",
    validations: ['required']
  }), /*#__PURE__*/React.createElement("div", {
    className: "VoucherCampaignEditor__ui.row ev78zum5 ev883omv ev1j4eaoi"
  }, /*#__PURE__*/React.createElement("div", {
    className: "VoucherCampaignEditor__ui.col_6 ev3dfncg evyzsjq7"
  }, /*#__PURE__*/React.createElement(OptionPicker, {
    name: "code_type",
    label: "Code Type",
    icon: "tag",
    options: [{
      code: 'Shared',
      value: 'SHARED',
      icon: "users"
    }, {
      code: 'Unique',
      value: 'UNIQUE',
      icon: "user"
    }],
    validations: ['required'],
    canFilter: false
  })), /*#__PURE__*/React.createElement("div", {
    className: "VoucherCampaignEditor__ui.col_6 ev3dfncg evyzsjq7"
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Code Length",
    icon: "hash",
    name: "code_length",
    validations: ['number']
  }))), /*#__PURE__*/React.createElement(OptionPicker, {
    name: "action_type",
    label: "Action Type",
    icon: "arrow-right",
    options: [{
      code: 'Grant Tier',
      value: 'GRANT_TIER'
    }, {
      code: 'Discount Fixed',
      value: 'APPLY_DISCOUNT_FIXED'
    }, {
      code: 'Discount Percent',
      value: 'APPLY_DISCOUNT_PERCENT'
    }],
    validations: ['required']
  }), /*#__PURE__*/React.createElement(Textarea, {
    label: "Action Payload",
    name: "action_payload"
  }), /*#__PURE__*/React.createElement(RichTextfield, {
    name: "description",
    label: "Description"
  }), /*#__PURE__*/React.createElement(FlexHorizontal, {
    style: {
      gap: 10,
      alignItems: "flex-end"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(PickDate, {
    name: "valid_from",
    label: "Valid From"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(PickTime, {
    name: "valid_from_time",
    icon: "clock"
  }))), /*#__PURE__*/React.createElement(FlexHorizontal, {
    style: {
      gap: 10,
      alignItems: "flex-end"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(PickDate, {
    name: "valid_until",
    label: "Valid Until"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(PickTime, {
    name: "valid_until_time",
    icon: "clock"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "VoucherCampaignEditor__ui.row ev78zum5 ev883omv ev1j4eaoi"
  }, /*#__PURE__*/React.createElement("div", {
    className: "VoucherCampaignEditor__ui.col_6 ev3dfncg evyzsjq7"
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Max Redemptions",
    icon: "trending-up",
    name: "max_redemptions"
  })), /*#__PURE__*/React.createElement("div", {
    className: "VoucherCampaignEditor__ui.col_6 ev3dfncg evyzsjq7"
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Max Per User",
    icon: "users",
    name: "max_redemptions_per_user",
    disabled: (campaignObject === null || campaignObject === void 0 ? void 0 : campaignObject.code_type) === 'UNIQUE'
  }))), /*#__PURE__*/React.createElement(OptionPicker, {
    name: "status",
    label: "Status",
    icon: 'loader',
    options: [{
      code: 'Active',
      value: 'ACTIVE'
    }, {
      code: 'Paused',
      value: 'PAUSED'
    }, {
      code: 'Expired',
      value: 'EXPIRED'
    }, {
      code: 'Archived',
      value: 'ARCHIVED'
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 30
  }), /*#__PURE__*/React.createElement(AddOrEditButton, {
    obj: "Campaign",
    processing: isProcessing,
    valid: isValid,
    edit: isEdit
  }))));
}

// @ts-ignore
_inject(".ev78zum5{display:flex}", 3000);
_inject(".ev883omv{gap:10px}", 2000);
_inject("@media(max-width:500px){.ev1j4eaoi.ev1j4eaoi{flex-direction:column}}", 3200);
_inject("@media(min-width:501px){.ev3dfncg.ev3dfncg{width:50%}}", 4200);
_inject("@media(max-width:500px){.evyzsjq7.evyzsjq7{width:100%}}", 4200);